import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import strings from "../../utils/property-file/requestPopUp.json";
import moment from "moment";
import {
  extractTime,
  convertUtcToIst,
} from "../../utils/commonFunction/timeConvertor";
import api from "../../services/api";
import { toast } from "react-toastify";
import PropTypes from "prop-types"
import SpinnerButtonMedium from "../button/SpinnerButtonMedium";

function DisputeModal(props) {
  const requestDetails = props.requestData;
  const [actionType, setActionType] = useState("");
  const [previewingRequestDecline, setPreviewingRequestDecline] = useState(false);
  const [previewingRequestApprove, setPreviewingRequestApprove] = useState(false);

  // Api for performing action 
  // In body : dispute id , status : "Approve / decline , date : date_of_attendance"

  const disputeAction = async (action) => {
    try {
      const body = {
        disputeId: requestDetails._id,
        status: action,
        date: moment.utc(requestDetails.actualInTime).format(strings.dateFormatLabel),
      }
      const response = await api.actionDispute(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          toast.success(data.body, { toastId: strings.error6 });
          setActionType("");
          props.onHide();
          props.dataFetch();
        }
        else {
          toast.error(data.body, { toastId: strings.error7 });
        }
      }
      setPreviewingRequestApprove(false);
      setPreviewingRequestDecline(false);
    }
    catch (error) {
      toast.error(error.message, { toastId: strings.error7 })
      setPreviewingRequestApprove(false);
      setPreviewingRequestDecline(false);
    }
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="request-pop-up"
    >
      <div className="main-header-container-request-pop-up">
        <div className="attendance-pop-up-name">
          {requestDetails.type ? (requestDetails.type === strings.bothLabel ? strings.bothIndicator : requestDetails.type + strings.disputeLabel) : strings.disputeDetailsLabel}
        </div>
        <div className="close-request-icon"><i className="ri-close-line" onClick={props.onHide}></i></div>
      </div>
      <div className="main-container-dispute">
        <div className="emp-details-disputes">
          <div>  {strings.empNameLabel}  : {requestDetails.username}</div>
          <div>  {strings.empIdLabel} : {requestDetails.empId}</div>
        </div>
        <div className="details-table-container">
          <table className="details-table">
            <thead >
              <tr >
                <th>{strings.actualCheckIn}</th>
                <th>{strings.actualCheckout}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{moment(requestDetails.actualInTime).format(strings.HHmmLAbel)}</td>
                <td>{requestDetails.actualOutTime? extractTime(convertUtcToIst(requestDetails.actualOutTime)) : strings.naLabel}</td>
              </tr>
            </tbody>
          </table>
          <table className="details-table">
            <thead >
              <tr >
                <th>{strings.dateOfAttendance}</th>
                <th>{strings.checkInLabel}</th>
                <th>{strings.requestedCheckOut}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{moment.utc(requestDetails.actualInTime).format("DD-MM-YYYY")}</td>
                <td>{requestDetails.inTime ? moment(requestDetails.inTime).format(strings.HHmmLAbel) : strings.naLabel}</td>
                <td>{requestDetails.outTime ? moment(requestDetails.outTime).format(strings.HHmmLAbel) : strings.naLabel}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <span className="reason-dispute"> {strings.reasonLabel} </span>  : {requestDetails.reason}
          </div>
        </div>
      </div>
      {actionType === "" ? <div className="request-attendance-button disputes-button">
        <button className="request-attendance-decline" onClick={() => setActionType(strings.rejectedLabel)}>
          {strings.declineLabel}
        </button>
        <button className="request-attendance-approve" onClick={() => setActionType(strings.approveLabel)}>
          {strings.approveLabel}
        </button>
      </div> : <div>
        <div className="confirmation-message">
          {strings.confirmationMessage}{actionType === strings.rejectedLabel ? strings.declineLabelForMessage : strings.approveLabelForMessage} {strings.questionMark}
        </div>
        <div className="request-attendance-button disputes-button">
          <button className="request-attendance-decline" disabled={previewingRequestDecline || previewingRequestApprove} onClick={() =>
            setActionType("")
          }>
            {strings.cancelLabel}
          </button>
          <button className="request-attendance-approve" disabled={previewingRequestDecline || previewingRequestApprove} onClick={(() => {
            if (actionType === strings.rejectedLabel) {
              setPreviewingRequestApprove(true);
              disputeAction(strings.rejectedLabel);
            }
            else {
              setPreviewingRequestApprove(true);
              disputeAction(strings.approvedLabel);
            }
          })}>
            {actionType === strings.rejectedLabel ? (previewingRequestApprove ? <SpinnerButtonMedium /> : strings.declineLabel) : previewingRequestApprove ? <SpinnerButtonMedium /> : strings.approveLabel}
          </button>
        </div>
      </div>}
    </Modal>
  );
}

DisputeModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  dataFetch: PropTypes.any.isRequired,
  requestData: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    actualInTime: PropTypes.string.isRequired,
    inTime: PropTypes.string.isRequired,
    actualOutTime: PropTypes.string.isRequired,
    outTime: PropTypes.string.isRequired,
    type: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    username: PropTypes.string.isRequired,
    empId: PropTypes.string.isRequired,
    reason: PropTypes.string.isRequired
  }).isRequired
};

export default DisputeModal;